import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ContactUpdateInputFieldInput,
    UpdateContactCustomFieldValue as UpdateContactCustomFieldValueMutation,
    UpdateContactCustomFieldValueVariables,
} from 'nutshell-graphql-types';

import UPDATE_CONTACT_CUSTOM_FIELD_VALUE from '../mutations/update-contact-custom-field-value.graphql';

export const useUpdateContactCustomFieldValue = (): {
    updateContactCustomFieldValue: (arg1: ContactUpdateInputFieldInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateContactCustomFieldValue, {loading, error}] = useMutation<
        UpdateContactCustomFieldValueMutation,
        UpdateContactCustomFieldValueVariables
    >(UPDATE_CONTACT_CUSTOM_FIELD_VALUE);

    return {
        updateContactCustomFieldValue: (contact: ContactUpdateInputFieldInput) =>
            updateContactCustomFieldValue({
                variables: {contact},
                refetchQueries: ['GetTopCustomFields', 'GetWidgetCustomFields'],
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
